export const TITLE = "activation.homepage.widget.rank_tracker.title";
export const TOOLTIP = "activation.homepage.widget.rank_tracker.tooltip";

export const EMPTY_MESSAGE = "activation.homepage.widget.rank_tracker.empty_message";
export const EMPTY_SCRAPING_MESSAGE = "activation.homepage.widget.rank_tracker.empty_message.scraping";

export const EMPTY_PROJECT_CTA = "activation.homepage.widget.rank_tracker.empty.no_project.button";
export const EMPTY_TOPIC_CTA = "activation.homepage.widget.rank_tracker.empty.no_topics.button";
export const EMPTY_RANK_TRACKER_CTA = "activation.rank.tracker.widget.track.button.text";

export const SHARED_TOPIC_CREATION_TOOLTIP = "activation.homepage.widget.rank_tracker.shared.creation.tooltip";
